import { motion } from "framer-motion";
import { Star } from "lucide-react";
import { hoverLift } from "@/lib/motion";
import type { Service, Testimonial, GalleryItem, StatItem, WhyUsItem } from "@/lib/index";
interface ServiceCardProps {
  service: Service;
}
export function ServiceCard({
  service
}: ServiceCardProps) {
  return <motion.div variants={hoverLift} initial="rest" whileHover="hover" className="relative bg-card rounded-2xl p-8 border border-border hover:border-accent transition-colors duration-500 overflow-hidden group">
      <div className="absolute inset-0 bg-gradient-to-br from-accent/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
      <div className="relative z-10">
        
        <h3 className="text-2xl font-semibold text-foreground mb-3 font-[Cairo]">
          {service.nameAr}
        </h3>
        <p className="text-muted-foreground leading-relaxed font-[Tajawal]">
          {service.descriptionAr}
        </p>
      </div>
    </motion.div>;
}
interface StatCardProps {
  stat: StatItem;
}
export function StatCard({
  stat
}: StatCardProps) {
  return <motion.div initial={{
    opacity: 0,
    scale: 0.9
  }} whileInView={{
    opacity: 1,
    scale: 1
  }} viewport={{
    once: true
  }} transition={{
    type: "spring",
    stiffness: 300,
    damping: 30
  }} className="text-center py-8 px-6">
      <div className="text-5xl md:text-6xl font-bold text-accent mb-2 font-[Playfair_Display]">
        {stat.value}
      </div>
      <div className="text-lg text-muted-foreground font-[Cairo]">
        {stat.labelAr}
      </div>
    </motion.div>;
}
interface TestimonialCardProps {
  testimonial: Testimonial;
}
export function TestimonialCard({
  testimonial
}: TestimonialCardProps) {
  return <motion.div variants={hoverLift} initial="rest" whileHover="hover" className="bg-card rounded-2xl p-8 border border-border shadow-sm">
      <div className="flex gap-1 mb-4">
        {Array.from({
        length: 5
      }).map((_, i) => <Star key={i} className={`w-5 h-5 ${i < testimonial.rating ? "fill-accent text-accent" : "text-muted"}`} />)}
      </div>
      <blockquote className="text-lg text-foreground mb-6 leading-relaxed font-[Tajawal] italic">
        "{testimonial.quoteAr}"
      </blockquote>
      <div className="border-t border-border pt-4">
        <div className="font-semibold text-foreground font-[Cairo]">
          {testimonial.nameAr}
        </div>
        <div className="text-sm text-muted-foreground font-[Tajawal]">
          {testimonial.companyAr}
        </div>
      </div>
    </motion.div>;
}
interface GalleryCardProps {
  item: GalleryItem;
}
export function GalleryCard({ item }: GalleryCardProps) {
  return (
    <motion.div
      variants={hoverLift}
      initial="rest"
      whileHover="hover"
      className="relative rounded-2xl overflow-hidden group cursor-pointer aspect-[4/3]"
    >
      <img
        src={item.image}
        alt={item.titleAr}
        className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-primary/90 via-primary/40 to-transparent opacity-60 group-hover:opacity-80 transition-opacity duration-500" />
      <div className="absolute bottom-0 left-0 right-0 p-6 transform translate-y-2 group-hover:translate-y-0 transition-transform duration-500">
        <h3 className="text-xl font-semibold text-white font-[Cairo]">
          {item.titleAr}
        </h3>
      </div>
    </motion.div>
  );
}
interface WhyUsCardProps {
  item: WhyUsItem;
}
export function WhyUsCard({
  item
}: WhyUsCardProps) {
  return <motion.div variants={hoverLift} initial="rest" whileHover="hover" className="relative bg-card rounded-2xl p-8 border border-border">
      
      
      <h3 className="text-xl font-semibold text-foreground mb-3 font-[Cairo]">
        {item.titleAr}
      </h3>
      <p className="text-muted-foreground leading-relaxed font-[Tajawal]">
        {item.descriptionAr}
      </p>
    </motion.div>;
}